import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';

const routes: Routes = [
    {path: '', pathMatch: 'full', redirectTo: 'main'},
    {path: 'main', loadChildren: () => import('./pages/main/main.module').then(m => m.MainComponentModule)},
    {path: 'admin', loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminComponentModule)},
    {path: 'product', loadChildren: () => import('./pages/product/product.module').then(m => m.ProductComponentModule)},
    {path: 'service', loadChildren: () => import('./pages/service/service.module').then(m => m.ServiceComponentModule)},
    {path: 'solution', loadChildren: () => import('./pages/solution/solution.module').then(m => m.SolutionComponentModule)},
    {path: 'about', loadChildren: () => import('./pages/about/about.module').then(m => m.AboutComponentModule)},
    // {path: 'news', loadChildren: () => import('./pages/news/news.module').then(m => m.NewsComponentModule)},
    {path: 'recruit', loadChildren: () => import('./pages/recruit/recruit.module').then(m => m.RecruitModule)},
    {path: 'contact', loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactComponentModule)},
    // {path: 'news-detail', loadChildren: () => import('./pages/news-detail/news-detail.module').then(m => m.NewsDetailComponentModule)},
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

